import { Component, OnInit, OnDestroy } from '@angular/core';
import { PriceService, GungFlowService, AuthService, PriceConfigService, LocationConfigService, GungAnonymousConfigService } from 'gung-standard';
import { ColmecJeevesProductCardComponent } from '../../product/colmec-jeeves-product-card/colmec-jeeves-product-card.component';
import { takeUntil } from 'rxjs';
import { ColmecConfigurableHelperService } from '../../../services/colmec-configurable-helper.service';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';

const buildExtraObjectWithValue = (value: any, pathStr: string): any => {
  const path = pathStr.split('.');
  const recursive = (current: {}, pathArr: string[], theValue: any) => {
    const [first, ...rest] = pathArr;
    if (!first) {
      return theValue;
    }
    current[first] = recursive({}, rest, theValue);
    return current;
  };
  return recursive({}, path, value);
};

@Component({
    selector: 'colmec-rim-card',
    templateUrl: './colmec-rim-card.component.html',
    styleUrls: ['./colmec-rim-card.component.scss'],
    standalone: false
})
export class ColmecRimCardComponent extends ColmecJeevesProductCardComponent implements OnInit, OnDestroy {
  targetStockId?: string;
  selectedRim: string;

  protected unsubscribe: Subject<void> = new Subject();

  constructor(
    protected priceService: PriceService,
    protected gungFlowService: GungFlowService,
    protected authService: AuthService,
    protected gungAnonymousConfigService: GungAnonymousConfigService,
    protected router: Router,
    protected locationConfigService: LocationConfigService,
    protected translateService: TranslateService,
    protected configurableHelperService: ColmecConfigurableHelperService,
    priceConfigService: PriceConfigService,
    protected activatedRoute: ActivatedRoute
  ) {
    super(
      priceService,
      gungFlowService,
      authService,
      gungAnonymousConfigService,
      router,
      locationConfigService,
      priceConfigService,
      translateService
    );
  }

  ngOnInit() {
    super.ngOnInit();
    this.configurableHelperService
      .getSelectedRim()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(selectedRim => {
        this.selectedRim = selectedRim;
      });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  addRim(rimId, parentProductId) {
    this.configurableHelperService.setSelectedRim(rimId);
  }
}
